import React from "react";
import { useEffect, useState } from "react";
import {
  FaUpload,
  FaEye,
  FaCloudUploadAlt,
  FaTrash,
  FaBoxOpen,
  FaBarcode,
  FaRegCalendarAlt,
  FaStore,
  FaRegBuilding,
  FaCheck,
  FaTimes,
  FaBuilding,
  FaReceipt,
  FaMoneyBillWave,
  FaPercentage,
  FaEdit,
  FaSave,
  FaFile,
  FaExternalLinkAlt,
} from "react-icons/fa";
import { BACKEND, API_PERU_URL, API_PERU_TOKEN } from "../../config/configEnvs";
import axios from "axios";
import { toast } from "react-toastify";
import Modal from "../../components/ui/Modal";
import FormLoader from "../ui/FormLoader";
import { FormatDateToDDMMYY } from "../../utils/FormatDate";
import InputFormValue from "../ui/components/InputFormValue";
import {months} from "../../utils/rawData/dateValues";
import { formatDate } from "../../utils/rawData/dateValues";
import EditButton from "../ui/components/EditButton";
import DeleteButton from "../ui/components/DeleteButton";
import { CategoriasCompras, SubcategoriasCompras } from "../../utils/plainValues/ClasificacionCompras";
import DetailsButton from "../ui/components/DetailsButton";
import { OptionsEntidadPago } from "../../utils/rawData/comprasValues";

const ItemRowRegistroCompra = ({ compra, handleSuccessChangeData, activeCols }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [showMultipleDocsModal, setShowMultipleDocsModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isUploadingMultiple, setIsUploadingMultiple] = useState(false);
  const [showMultipleDocsViewModal, setShowMultipleDocsViewModal] = useState(false);
  const [isEditingDocs, setIsEditingDocs] = useState(false);
  const [existingDocs, setExistingDocs] = useState([]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type.startsWith("image/") || file.type === "application/pdf") {
        setSelectedFile(file);
      } else {
        toast.warning("Solo se permiten archivos de imagen o PDF", {
          position: "top-right",
        });
        event.target.value = null;
      }
    }
  };

  const openModalAdd = () => {
    setShowPurchaseModal(true);
  };

  const closeModalAdd = () => {
    setShowPurchaseModal(false);
  };

  const openMultipleDocsModal = () => {
    setShowMultipleDocsModal(true);
  };

  const closeMultipleDocsModal = () => {
    setShowMultipleDocsModal(false);
    setSelectedFiles([]);
  };

  const openEditDocsModal = () => {
    setExistingDocs(compra.documentos || []);
    setIsEditingDocs(true);
    setShowMultipleDocsViewModal(true);
  };

  const closeEditDocsModal = () => {
    setIsEditingDocs(false);
    setExistingDocs([]);
    setSelectedFiles([]);
    setShowMultipleDocsViewModal(false);
  };

  const handleMultipleFilesChange = (event) => {
    const files = Array.from(event.target.files);
    const validFiles = files.filter(file => 
      file.type.startsWith("image/") || file.type === "application/pdf"
    );
    
    if (validFiles.length !== files.length) {
      toast.warning("Algunos archivos no son válidos. Solo se permiten imágenes y PDFs", {
        position: "top-right",
      });
    }
    
    setSelectedFiles(validFiles);
  };

  const removeFile = (index) => {
    setSelectedFiles(prev => prev.filter((_, i) => i !== index));
  };

  const removeExistingDoc = (index) => {
    setExistingDocs(prev => prev.filter((_, i) => i !== index));
  };

  const deleteImageFromServer = async (imageId) => {
    try {
      await axios.delete(`${BACKEND}/api/comprasImagenes/${imageId}`, { withCredentials: true });
    } catch (error) {
      console.error("Error al eliminar imagen del servidor:", error);
      // No mostramos error al usuario para no interrumpir el flujo
    }
  };

  const handleSaveDocumentChanges = async () => {
    setIsUploadingMultiple(true);
    try {
      const uploadedMediaIds = [];

      // Subir nuevos archivos
      for (const file of selectedFiles) {
        const formData = new FormData();
        formData.append("file", file);

        const response = await axios.post(
          `${BACKEND}/api/comprasImagenes`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        uploadedMediaIds.push(response.data.doc.id);
      }

      // Identificar documentos eliminados (los que estaban en compra.documentos pero no en existingDocs)
      const originalDocs = compra.documentos || [];
      const docsToDelete = originalDocs.filter(doc => 
        !existingDocs.some(existingDoc => existingDoc.id === doc.id)
      );

      // Eliminar documentos del servidor que fueron removidos
      for (const docToDelete of docsToDelete) {
        await deleteImageFromServer(docToDelete.id);
      }

      // Agregar IDs de documentos existentes que no fueron eliminados
      const finalDocs = [...existingDocs.map((d) => d.id), ...uploadedMediaIds];

      // Actualizar la compra con todos los documentos
      await axios.put(`${BACKEND}/api/compras/${compra.id}`, {
        documentos: finalDocs,
      }, { withCredentials: true });

      setSelectedFiles([]);
      
      // Mostrar mensaje informativo sobre las acciones realizadas
      let message = "Documentos actualizados exitosamente";
      if (docsToDelete.length > 0 && selectedFiles.length > 0) {
        message = `${docsToDelete.length} documento(s) eliminado(s) y ${selectedFiles.length} nuevo(s) agregado(s)`;
      } else if (docsToDelete.length > 0) {
        message = `${docsToDelete.length} documento(s) eliminado(s)`;
      } else if (selectedFiles.length > 0) {
        message = `${selectedFiles.length} nuevo(s) documento(s) agregado(s)`;
      }
      
      toast.success(message, {
        position: "top-right",
      });
      handleSuccessChangeData();
      closeEditDocsModal();
    } catch (error) {
      console.error("Error al actualizar los documentos:", error);
      toast.error("Error al actualizar los documentos");
    } finally {
      setIsUploadingMultiple(false);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.warning("No hay ningún archivo seleccionado", {
        position: "top-right",
      });
      return;
    }

    setIsUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", selectedFile);

      const response = await axios.post(
        `${BACKEND}/api/comprasImagenes`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const mediaId = response.data.doc.id;

      await axios.put(`${BACKEND}/api/compras/${compra.id}`, {
        imagen: mediaId,
      }, { withCredentials: true });
      setSelectedFile(null);
      toast.success("Archivo subido exitosamente", {
        position: "top-right",
      });
      handleSuccessChangeData();
      closeModalAdd();
    } catch (error) {
      console.error("Error al subir el archivo:", error);
      toast.error("Error al subir el archivo");
    } finally {
      setIsUploading(false);
    }
  };

  const handleUploadMultiple = async () => {
    if (selectedFiles.length === 0) {
      toast.warning("No hay archivos seleccionados", {
        position: "top-right",
      });
      return;
    }

    setIsUploadingMultiple(true);
    try {
      const uploadedMediaIds = [];

      // Subir cada archivo
      for (const file of selectedFiles) {
        const formData = new FormData();
        formData.append("file", file);

        const response = await axios.post(
          `${BACKEND}/api/comprasImagenes`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        uploadedMediaIds.push(response.data.doc.id);
      }

      // Eliminar documentos existentes si los hay
      const existingDocs = compra.documentos || [];
      for (const existingDoc of existingDocs) {
        await deleteImageFromServer(existingDoc.id);
      }

      // Actualizar la compra con todos los documentos
      await axios.put(`${BACKEND}/api/compras/${compra.id}`, {
        documentos: uploadedMediaIds,
      }, { withCredentials: true });

      setSelectedFiles([]);
      
      let message = `${selectedFiles.length} documentos subidos exitosamente`;
      if (existingDocs.length > 0) {
        message = `${existingDocs.length} documento(s) anterior(es) eliminado(s) y ${selectedFiles.length} nuevo(s) subido(s)`;
      }
      
      toast.success(message, {
        position: "top-right",
      });
      handleSuccessChangeData();
      closeMultipleDocsModal();
    } catch (error) {
      console.error("Error al subir los archivos:", error);
      toast.error("Error al subir los archivos");
    } finally {
      setIsUploadingMultiple(false);
    }
  };

  const handleDelete = async () => {
    try {

      const confirm = window.confirm("¿Estás seguro de querer eliminar esta compra?");
      if (!confirm) return;

      // Eliminar la imagen principal si existe
      if (compra.imagen) {
        await deleteImageFromServer(compra.imagen.id);
      }

      // Eliminar todos los documentos asociados si existen
      const documents = compra.documentos || [];
      for (const doc of documents) {
        await deleteImageFromServer(doc.id);
      }
      
      // Luego eliminar la compra
      await axios.delete(`${BACKEND}/api/compras/${compra.id}`, { withCredentials: true });
      
      handleSuccessChangeData();
      toast.success("Compra eliminada exitosamente");
    } catch (error) {
      console.error("Error al eliminar la compra:", error);
      toast.error("Error al eliminar la compra");
    }
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  // Editar compra

  const [newRuc, setNewRuc] = useState(compra.ruc);
  const [validRUC, setValidRUC] = useState(false);
  const [isRucLoading, setIsRucLoading] = useState(false);

  const fetchRUC = async () => {
    if (validRUC) {
      toast.info("El RUC ya ha sido validado", { position: "top-right" });
      return;
    }
    if (newRuc === "") {
      toast.warning("Para validar el RUC primero completa el campo", {
        position: "top-right",
      });
      return;
    }
    if (newRuc?.length !== 11) {
      toast.warning("RUC inválido", { position: "top-right" });
      return;
    }
    setIsRucLoading(true);
    try {
      const response = await axios.post(
        `${API_PERU_URL}ruc`,
        { ruc: newRuc },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${API_PERU_TOKEN}`,
          },
        }
      );

      const payload = response.data?.data;
      if (!response.data?.success || !payload?.nombre_o_razon_social) {
        toast.warning("Este RUC no existe o no se pudo validar", {
          position: "top-right",
        });
        return;
      }

      setFormValuesCompra((prev) => ({
        ...prev,
        ruc: newRuc,
        razon_social: payload.nombre_o_razon_social,
      }));
      toast.success("RUC validado correctamente", { position: "top-right" });
      setValidRUC(true);
    } catch (error) {
      console.error("Error al validar el RUC:", error);
      toast.warning("Este RUC no existe o no se pudo validar", {
        position: "top-right",
      });
    } finally {
      setIsRucLoading(false);
    }
  };

  const [showEditPurchaseModal, setShowEditPurchaseModal] = useState(false);

  const [formValuesCompra, setFormValuesCompra] = useState({
    entidad: compra.entidad,
    fecha_pago: compra.fecha_pago,
    fecha_pago_real: compra.fecha_pago_real,
    igv: compra.igv,
    importe_total: compra.importe_total,
    moneda: compra.moneda,
    nombre_item: compra.nombre_item,
    numero_comprobante: compra.numero_comprobante,
    razon_social: compra.razon_social,
    ruc: newRuc,
    subtotal: compra.subtotal,
    tipo_doc: compra.tipo_doc,
    costo_unitario: compra.costo_unitario,
    cantidad: compra.cantidad,
    tipoCosto: compra.tipoCosto,
    tipoPago: compra.tipoPago,
    cantidadTiempo: compra.cantidadTiempo,
    estadoPago: compra.estadoPago,
    categoria: compra.categoria || "Infraestructura Tecnológica.",
    subcategoria: compra.subcategoria || "Hosting.",
  });

  useEffect(() => {
    if (formValuesCompra.tipo_doc === "factura") {
      const calculatedIgv = (formValuesCompra.subtotal * 0.18)?.toFixed(2);
      const importeTotal = (
        parseFloat(formValuesCompra.subtotal) + parseFloat(calculatedIgv)
      ).toFixed(2);
      setFormValuesCompra((prevValues) => ({
        ...prevValues,
        igv: calculatedIgv,
        importe_total: importeTotal,
      }));
    } else {
      setFormValuesCompra((prevValues) => ({
        ...prevValues,
        igv: 0,
        importe_total: parseFloat(compra.subtotal)?.toFixed(2),
      }));
    }
  }, [formValuesCompra.tipo_doc, formValuesCompra.subtotal]);

  useEffect(() => {
    if (formValuesCompra.tipoPago === "Unico") {
      setFormValuesCompra(prev => ({
        ...prev,
        cantidadTiempo: 1
      }));
    }
  }, [formValuesCompra.tipoPago]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue =
      name === "subtotal" || name === "igv" || name === "costo_unitario" || name === "cantidad" || name === "cantidadTiempo" 
        ? Number(value) 
        : value;
    
    setFormValuesCompra({
      ...formValuesCompra,
      [name]: newValue,
    });

    // Recalcular subtotal si cambia costo_unitario o cantidad
    if (name === "costo_unitario" || name === "cantidad") {
      const newSubtotal = formValuesCompra.costo_unitario * formValuesCompra.cantidad;
      setFormValuesCompra(prev => ({
        ...prev,
        subtotal: newSubtotal,
        igv: formValuesCompra.tipo_doc === "factura" ? newSubtotal * 0.18 : 0,
        importe_total: formValuesCompra.tipo_doc === "factura" 
          ? newSubtotal + (newSubtotal * 0.18)
          : newSubtotal
      }));
    }
  };

  useEffect(() => {
    setFormValuesCompra({
      ...formValuesCompra,
      ruc: newRuc,
    });
  }, [newRuc]);

  const handleEditPurchase = async () => {
    try {
      // Calcular montos
      const subtotal = formValuesCompra.costo_unitario * formValuesCompra.cantidad;
      const igv = formValuesCompra.tipo_doc === "factura" ? subtotal * 0.18 : 0;
      const importe_total = subtotal + igv;

      // Preparar datos para enviar
      const dataToSend = {
        ...formValuesCompra,
        subtotal,
        igv,
        importe_total,
        fecha_pago: formValuesCompra.fecha_pago ? new Date(formValuesCompra.fecha_pago).toISOString() : null
      };

      await axios.put(`${BACKEND}/api/compras/${compra.id}`, dataToSend, { withCredentials: true });
      handleSuccessChangeData();
      toast.success("Compra actualizada correctamente");
      setShowEditPurchaseModal(false);
    } catch (error) {
      toast.error("Error al actualizar la compra");
    }
  };

  return (
    <>
      {/* Modal de edición de compra */}
      <Modal
        activeModal={showEditPurchaseModal}
        title={`Editar Compra`}
        onClose={() => setShowEditPurchaseModal(false)}
        centered={true}
        className="max-w-3xl"
      >
        <div className="flex flex-col md:flex-row gap-4 overflow-y-auto max-h-[75vh]">
          <div className="flex flex-col gap-4 w-full md:w-1/2">
            <InputFormValue
              title="Nombre del ítem"
              info="Nombre del ítem o servicio con el que se registró la compra."
              value={formValuesCompra.nombre_item}
              disabled={true}
              icon={<FaBoxOpen />}
              placeholder="Nombre del ítem o servicio"
              type="text"
            />

            <InputFormValue
              required={true}
              title="Fecha de emisión"
              info="Fecha en la que se realizó la emisión del ítem o servicio."
              value={formValuesCompra.fecha_pago?.split("T")[0]}
              setValue={(value) => setFormValuesCompra(prev => ({ ...prev, fecha_pago: value }))}
              icon={<FaRegCalendarAlt />}
              placeholder="Fecha de emisión"
              type="date"
            />

            <InputFormValue
              required={true}
              title="Fecha de pago"
              info="Fecha en la que se realizó el pago del ítem o servicio."
              value={formValuesCompra.fecha_pago_real?.split("T")[0]}
              setValue={(value) => setFormValuesCompra(prev => ({ ...prev, fecha_pago_real: value }))}
              icon={<FaRegCalendarAlt />}
              placeholder="Fecha de pago"
              type="date"
            />

            <InputFormValue
              required={true}
              title="Costo unitario del ítem o servicio."
              min={0}
              info="Costo por unidad del ítem o servicio."
              value={formValuesCompra.costo_unitario}
              setValue={(value) => setFormValuesCompra(prev => ({ ...prev, costo_unitario: value }))}
              icon={<FaMoneyBillWave />}
              placeholder="Costo unitario"
              type="number"
            />

            <InputFormValue
              disabled={true}
              title="Moneda"
              info="Moneda con la que se registró la compra."
              value={formValuesCompra.moneda}
              icon={<FaMoneyBillWave />}
              placeholder="Moneda"
              type="select"
              options={[
                { value: "soles", label: "Soles" },
                { value: "dolares", label: "Dolares" },
              ]}
            />

            <InputFormValue
              required={true}
              title="Cantidad de ítems"
              min={0}
              info="Cantidad de unidades o cuentas del ítem o servicio."
              value={formValuesCompra.cantidad}
              setValue={(value) => setFormValuesCompra(prev => ({ ...prev, cantidad: value }))}
              icon={<FaBoxOpen />}
              placeholder="Cantidad"
              type="number"
            />

            <InputFormValue
              title="Tipo de pago."
              info="El tipo con el cual se registró este pago al momento de su registro."
              value={formValuesCompra.tipoPago}
              icon={<FaMoneyBillWave />}
              placeholder="Tipo de pago"
              type="select"
              disabled={true}
              options={[
                { value: "Unico", label: "Unico" },
                { value: "Mensual", label: "Mensual" },
                { value: "Anual", label: "Anual" },
              ]}
            />

            <InputFormValue
              title="Entidad."
              info="Entidad (banco) con cuya tarjeta se realizó el pago."
              value={formValuesCompra.entidad}
              setValue={(value) => setFormValuesCompra(prev => ({ ...prev, entidad: value }))}
              icon={<FaMoneyBillWave />}
              placeholder="Entidad"
              type="select"
              options={OptionsEntidadPago}
            />

            <InputFormValue
              title="Número de comprobante"
              info="Número del comprobante de pago en caso se requiera."
              value={formValuesCompra.numero_comprobante}
              setValue={(value) => setFormValuesCompra(prev => ({ ...prev, numero_comprobante: value }))}
              icon={<FaBarcode />}
              placeholder="Número de comprobante de pago"
              type="text"
            />

          </div>

          <div className="flex flex-col gap-4 w-full md:w-1/2">

            <InputFormValue
              title="Categoría"
              info="Categoría del ítem o servicio."
              value={formValuesCompra.categoria}
              setValue={(value) => setFormValuesCompra(prev => ({ ...prev, categoria: value }))}
              icon={<FaMoneyBillWave />}
              placeholder="Categoría"
              type="select"
              options={CategoriasCompras}
              required={true}
            />

            <InputFormValue
              title="Subcategoría"
              info="Subcategoría del ítem o servicio."
              value={formValuesCompra.subcategoria}
              setValue={(value) => setFormValuesCompra(prev => ({ ...prev, subcategoria: value }))}
              icon={<FaMoneyBillWave />}
              placeholder="Subcategoría"
              type="select"
              options={SubcategoriasCompras.filter(e => e.category === formValuesCompra.categoria)}
              required={true}
            />

            <div className="flex flex-col gap-1">
              <label className="flex flex-row items-center text-xs block text-gray-700">
                RUC
              </label>
              <div className="flex">
                <span className="text-xs inline-flex items-center px-3 text-xs text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                  <FaRegBuilding className="w-4 h-4 text-gray-500 " />
                </span>
                <input
                  type="text"
                  id="ruc"
                  value={newRuc}
                  disabled={validRUC}
                  onChange={(e) => setNewRuc(e.target.value)}
                  className="text-xs rounded-none bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-xs border-gray-300 p-2.5  "
                  placeholder="RUC"
                />

                {validRUC ? (
                  <>
                    <div className="text-xs inline-flex gap-2 items-center px-3 text-xs text-white bg-green-500 border rounded-e-0 border-gray-300 border-e-0 rounded-e-0">
                      Validado
                      <FaCheck className="text-white" />
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        setValidRUC(false);
                        setNewRuc("");
                        setFormValuesCompra({
                          ...formValuesCompra,
                          ruc: "",
                          razon_social: "",
                        });
                      }}
                      className="text-xs inline-flex items-center px-2 py-1 text-xs text-gray-900 bg-red-200 border rounded-e-md border-gray-300 hover:bg-red-300"
                    >
                      <FaTimes className="w-4 h-4 text-red-500" />
                      <span className="sr-only text-xs">Eliminar validación</span>
                    </button>
                  </>
                ) : (
                  <button
                    type="button"
                    disabled={isRucLoading}
                    onClick={fetchRUC}
                    className="text-xs inline-flex gap-2 items-center px-3 text-xs text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-e-md "
                  >
                    {isRucLoading ? (
                      <FormLoader colour={"#F64000"} className={" w-4"} />
                    ) : (
                      <>
                        Validar
                        <FaCheck />
                      </>
                    )}
                  </button>
                )}
              </div>
            </div>

            <InputFormValue
              title="Nombre del proveedor"
              info="Nombre del proveedor del ítem o servicio."
              value={formValuesCompra.razon_social}
              setValue={(value) => setFormValuesCompra(prev => ({ ...prev, razon_social: value }))}
              icon={<FaStore />}
              placeholder="Nombre del proveedor"
              type="text"
            />

            <InputFormValue
              required={true}
              title="Tipo de documento"
              info="Tipo de documento (factura, boleta, recibo)."
              value={formValuesCompra.tipo_doc}
              setValue={(value) => setFormValuesCompra(prev => ({ ...prev, tipo_doc: value }))}
              icon={<FaReceipt />}
              placeholder="Tipo de documento"
              type="select"
              options={[
                { label: "Factura", value: "factura" },
                { label: "Boleta", value: "boleta" },
                { label: "RH", value: "RH" },
                { label: "Proforma", value: "proforma" },
                { label: "Nota de credito", value: "nota_credito" },
                { label: "Nota de debito", value: "nota_debito" },
                { label: "Ticket", value: "ticket" },
                { label: "POS", value: "POS" },
                { label: "Recibo", value: "recibo" },
              ]}
            />

            <InputFormValue
              required={true}
              title="Subtotal"
              info="Subtotal del ítem o servicio."
              value={formValuesCompra.cantidad * formValuesCompra.costo_unitario}
              icon={<FaMoneyBillWave />}
              placeholder="Subtotal"
              type="number"
              disabled={true}
            />

            <InputFormValue
              title="IGV por pago"
              info="IGV del ítem o servicio."
              value={formValuesCompra.igv}
              className={`text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-xs border-gray-300 p-2.5`}
              icon={<FaPercentage />}
              placeholder="IGV"
              type="number"
              disabled={true}
            />

            <InputFormValue
              title="Estado de pago"
              info="Estado del pago del ítem o servicio."
              value={formValuesCompra.estadoPago}
              setValue={(value) => setFormValuesCompra(prev => ({ ...prev, estadoPago: value }))}
              className={`text-xs rounded-l-none rounded-r-lg bg-gray-50 border focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-xs border-gray-300 p-2.5`}
              icon={<FaPercentage />}
              placeholder="Estado de pago"
              type="select"
              options={[
                { label: "Pendiente", value: "Pendiente" },
                { label: "Pagado", value: "Pagado" },
              ]}
            />
          </div>
        </div>

        {formValuesCompra.moneda && formValuesCompra.tipoPago && formValuesCompra.cantidadTiempo && formValuesCompra.fecha_pago && (
          <span className="text-xs text-gray-500">
            {formValuesCompra.tipoPago === "Unico" 
              ? `Se generará un pago único de ${formValuesCompra.subtotal} ${formValuesCompra.moneda}`
              : formValuesCompra.tipoPago === "Mensual" 
                ? `Se generará un pago de ${formValuesCompra.subtotal} ${formValuesCompra.moneda} los ${new Date(formValuesCompra.fecha_pago).getDate()} de cada mes por ${formValuesCompra.cantidadTiempo} meses`
                : `Se generará un pago de ${formValuesCompra.subtotal} ${formValuesCompra.moneda} los ${new Date(formValuesCompra.fecha_pago).getDate()} de ${new Date(formValuesCompra.fecha_pago).toLocaleString('es-ES', { month: 'long' })} de cada año por ${formValuesCompra.cantidadTiempo} años`
            }
          </span>
        )}

        <div className="flex w-full mt-4 items-center justify-center gap-4">
          <button
            type="button"
            onClick={() => setShowEditPurchaseModal(false)}
            className="text-xs bg-gray-600 text-white rounded-lg px-4 py-2 w-1/2 font-bold flex justify-center items-center gap-2"
          >
            <FaTimes />
            Cancelar
          </button>
          <button
            className="text-xs bg-orange-500 text-white rounded-lg px-4 py-2 w-1/2 font-bold flex justify-center items-center gap-2"
            onClick={handleEditPurchase}
          >
            <FaSave />
            Actualizar
          </button>
        </div>
      </Modal>

      {/* Modal de vista de imagen o pdf */}
      <Modal
        onClose={() => setShowImageModal(false)}
        activeModal={showImageModal}
        title="Vista de Archivo"
        centered
      >
        <div className="flex items-center justify-center">
          {compra.imagen && (
            compra?.imagen?.mimeType === "application/pdf" ? (
              <iframe
                src={compra?.imagen.url}
                title="Archivo PDF"
                width="100%"
                height="70vh"  
                style={{ border: "none" }}
              />
            ) : (
              <img
                src={compra?.imagen.url}
                alt="Imagen de compra"
                style={{ maxWidth: "100%", maxHeight: "70vh" }}
              />
            )
          )}
        </div>
      </Modal>

      {/* Modal de subida de imagen o pdf */}
      <Modal
        onClose={() => setShowPurchaseModal(false)}
        activeModal={showPurchaseModal}
        title="Subir imagen de compra"
        centered
      >
        <div className="mb-4">
          <label className="block text-xs text-gray-700 mb-2" htmlFor="archivo">
            Archivo
          </label>
          <input
            type="file"
            id="archivo"
            name="archivo"
            accept="image/*, application/pdf"
            onChange={handleFileChange}
            className="w-full text-xs border border-gray-300 rounded-lg"
          />
        </div>

        <div className="flex w-full mt-4 items-center justify-center gap-4">
          <button
            type="button"
            onClick={closeModalAdd}
            className="text-xs bg-gray-600 text-white rounded-lg px-4 py-2 w-1/2 font-bold flex justify-center items-center gap-2"
          >
            <FaTimes />
            Cancelar
          </button>
          <button
            type="submit"
            className="text-xs bg-orange-500 text-white rounded-lg px-4 py-2 w-1/2 font-bold flex justify-center items-center gap-2"
            onClick={handleUpload}
          >
            <FaSave />
            Guardar
          </button>
        </div>
      </Modal>

      {/* Modal para subir múltiples documentos de venta */}
      <Modal
        onClose={closeMultipleDocsModal}
        activeModal={showMultipleDocsModal}
        title="Subir múltiples documentos de venta"
        centered
        className="max-w-2xl"
      >
        <div className="space-y-4">

          {/* Área de selección de archivos */}
          <div className="mb-4">
            <label className="block text-xs text-gray-700 mb-2 font-medium">
              Seleccionar documentos
            </label>
            <input
              type="file"
              multiple
              accept="image/*, application/pdf"
              onChange={handleMultipleFilesChange}
              className="w-full text-xs border border-gray-300 rounded-lg"
            />
            <p className="text-xs text-gray-500 mt-2">
              Puedes seleccionar múltiples archivos. Solo se permiten imágenes y PDFs.
            </p>
          </div>

          {/* Lista de archivos seleccionados */}
          {selectedFiles.length > 0 && (
            <div className="mb-4">
              <label className="block text-gray-700 mb-2 font-medium">
                Archivos seleccionados ({selectedFiles.length})
              </label>
              <div className="max-h-40 overflow-y-auto border border-gray-200 rounded-lg p-2">
                {selectedFiles.map((file, index) => (
                  <div key={index} className="flex items-center justify-between py-2 px-3 bg-gray-50 rounded mb-2">
                    <div className="flex items-center space-x-2">
                      <FaFile className="text-blue-500" />
                      <span className="text-xs text-gray-700 truncate max-w-xs">
                        {file.name}
                      </span>
                      <span className="text-xs text-gray-500">
                        ({(file.size / 1024 / 1024).toFixed(2)} MB)
                      </span>
                    </div>
                    <DeleteButton 
                      action={() => removeFile(index)}
                      content="Eliminar archivo"
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Botones de acción */}
          <div className="flex w-full mt-4 items-center justify-center gap-4">
            <button
              type="button"
              onClick={closeMultipleDocsModal}
              className="text-xs bg-gray-600 text-white rounded-lg px-4 py-2 w-1/2 font-bold flex justify-center items-center gap-2"
            >
              <FaTimes />
              Cancelar
            </button>
            <button
              type="submit"
              className="text-xs bg-orange-500 text-white rounded-lg px-4 py-2 w-1/2 font-bold flex justify-center items-center gap-2"
              onClick={handleUploadMultiple}
            >
              {isUploadingMultiple ? (
                <>
                  <FormLoader colour={"#FFFFFF"} className={"w-4 h-4"} />
                  <span>Subiendo...</span>
                </>
              ) : (
                <>
                  <FaCloudUploadAlt />
                  <span>Subir {selectedFiles.length} documento{selectedFiles.length !== 1 ? 's' : ''}</span>
                </>
              )}
            </button>
          </div>
        </div>
      </Modal>

      {/* Modal para visualizar múltiples documentos */}
      <Modal
        onClose={isEditingDocs ? closeEditDocsModal : () => setShowMultipleDocsViewModal(false)}
        activeModal={showMultipleDocsViewModal}
        title={isEditingDocs ? "Editar documentos de venta" : "Documentos de venta"}
        centered
        className="max-w-4xl"
      >
        <div className="space-y-4 max-h-[80vh] overflow-y-auto">
          {/* Modo de edición - Documentos existentes */}
          {isEditingDocs && (
            <div className="mb-4">
              <h3 className="text-xs font-medium text-gray-700 mb-2">Documentos existentes</h3>
              {existingDocs.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-[50vh] overflow-y-auto">
                  {existingDocs.map((doc, index) => (
                    <div key={index} className="border border-gray-200 rounded-lg p-3 relative">
    
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-xs font-medium text-gray-700">
                          Documento {index + 1}
                        </span>
                        <div className="flex items-center gap-2">
                          <DetailsButton 
                            action={() => window.open(doc.url, '_blank')} 
                            content="Ver documento" 
                            type="externalLink" 
                          />
                          <DeleteButton action={() => removeExistingDoc(index)} content="Eliminar documento" />
                        </div>
                      </div>
                      <div className="aspect-video bg-gray-100 rounded overflow-hidden">
                        {doc.mimeType === "application/pdf" ? (
                          <iframe
                            src={doc.url}
                            title={`Documento ${index + 1}`}
                            width="100%"
                            height="100%"
                            style={{ border: "none" }}
                          />
                        ) : (
                          <img
                            src={doc.url}
                            alt={`Documento ${index + 1}`}
                            className="w-full h-full object-cover"
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-4 text-gray-500 border border-gray-200 rounded-lg">
                  <FaFile className="mx-auto text-2xl mb-2 text-gray-300" />
                  <p className="text-xs">No hay documentos existentes</p>
                </div>
              )}
            </div>
          )}

          {/* Modo de edición - Agregar nuevos documentos */}
          {isEditingDocs && (
            <div className="mb-4">
              <h3 className="text-xs font-medium text-gray-700 mb-2">Agregar nuevos documentos</h3>
              <div className="mb-4">
                <input
                  type="file"
                  multiple
                  accept="image/*, application/pdf"
                  onChange={handleMultipleFilesChange}
                  className="w-full border text-xs border-gray-300 rounded-lg"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Puedes seleccionar múltiples archivos. Solo se permiten imágenes y PDFs.
                </p>
              </div>

              {/* Lista de nuevos archivos seleccionados */}
              {selectedFiles.length > 0 && (
                <div className="mb-4">
                  <label className="block text-gray-700 mb-2 text-xs font-medium">
                    Nuevos archivos seleccionados ({selectedFiles.length})
                  </label>
                  <div className="max-h-32 overflow-y-auto border border-gray-200 rounded-lg p-2">
                    {selectedFiles.map((file, index) => (
                      <div key={index} className="flex items-center justify-between py-2 px-3 bg-gray-50 rounded mb-2">
                        <div className="flex items-center space-x-2">
                          <FaFile className="text-blue-500" />
                          <span className="text-xs text-gray-700 truncate max-w-xs">
                            {file.name}
                          </span>
                          <span className="text-xs text-gray-500">
                            ({(file.size / 1024 / 1024).toFixed(2)} MB)
                          </span>
                        </div>
                        <DeleteButton 
                          action={() => removeFile(index)}
                          content="Eliminar archivo"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Modo de visualización normal */}
          {!isEditingDocs && (
            <>
              {compra.documentos && compra.documentos.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-96 overflow-y-auto">
                  {compra.documentos.map((doc, index) => (
                    <div key={index} className="border border-gray-200 rounded-lg p-3">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-xs font-medium text-gray-700">
                          Documento {index + 1}
                        </span>
                        <DetailsButton 
                          action={() => window.open(doc.url, '_blank')} 
                          content="Ver documento" 
                          type="externalLink"
                        />
                      </div>
                      <div className="aspect-video bg-gray-100 rounded overflow-hidden">
                        {doc.mimeType === "application/pdf" ? (
                          <iframe
                            src={doc.url}
                            title={`Documento ${index + 1}`}
                            width="100%"
                            height="100%"
                            style={{ border: "none" }}
                          />
                        ) : (
                          <img
                            src={doc.url}
                            alt={`Documento ${index + 1}`}
                            className="w-full h-full object-cover"
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-8 text-gray-500">
                  <FaFile className="mx-auto text-4xl mb-2 text-gray-300" />
                  <p>No hay documentos de venta subidos</p>
                </div>
              )}
            </>
          )}

          {/* Botones de acción para modo de edición */}
          {isEditingDocs && (
            <div className="flex justify-end space-x-3 pt-4 border-t">
              <button
                type="button"
                onClick={closeEditDocsModal}
                className="bg-gray-500 text-white rounded-lg px-4 py-2 text-xs font-medium hover:bg-gray-600 transition-colors"
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={handleSaveDocumentChanges}
                disabled={isUploadingMultiple}
                className="bg-orange-500 text-white rounded-lg px-4 py-2 text-xs font-medium hover:bg-orange-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2"
              >
                {isUploadingMultiple ? (
                  <>
                    <FormLoader colour={"#FFFFFF"} className={"w-4 h-4"} />
                    <span>Guardando...</span>
                  </>
                ) : (
                  <>
                    <FaSave />
                    <span>Guardar cambios</span>
                  </>
                )}
              </button>
            </div>
          )}
        </div>
      </Modal>

      <tr className="text-xs py-3 w-full hover:bg-gray-100 transition-all duration-100">
        
        {/* Acciones */}
        {activeCols.find((e) => e.id === 1)?.show && (
          <td scope="row" className="px-4 py-3  text-center whitespace-nowrap border border-gray-300">
            <div className="flex justify-center items-center gap-2">
              <EditButton action={() => setShowEditPurchaseModal(true)} content="Editar compra" />
              <DeleteButton action={handleDelete} content="Eliminar compra" />
            </div>
          </td>
        )}
      
        {/* Fecha emisión */}
        {activeCols.find((e) => e.id === 2)?.show && (
          <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
            {compra.fecha_pago ? formatDate(compra.fecha_pago.split("T")[0]) : "-"}
          </td>
        )}
        
        {/* RUC */}
        {activeCols.find((e) => e.id === 3)?.show && (
          <td scope="row" className={`px-4 py-3  text-center whitespace-nowrap border border-gray-300 ${compra.ruc ? "text-black" : "text-gray-200"}`}>
            {compra.ruc ? compra.ruc : "-"}
          </td>
        )}

        {/* Proveedor */}
        {activeCols.find((e) => e.id === 4)?.show && (
          <td scope="row" className={`px-4 py-3  text-center whitespace-nowrap border border-gray-300 ${compra.razon_social ? "text-black" : "text-gray-200"}`}>
            {compra.razon_social ? compra.razon_social : "-"}
          </td>
        )}

        {/* Descripción */}
        {activeCols.find((e) => e.id === 5)?.show && (
          <td scope="row" className={`px-4 py-3  text-center whitespace-nowrap border border-gray-300 ${compra.nombre_item ? "text-black" : "text-gray-200"}`}>
            {compra.nombre_item}
          </td>
        )}

        {/* Tipo de comprobante */}
        {activeCols.find((e) => e.id === 6)?.show && (
          <td scope="row" className={`px-4 py-3  text-center whitespace-nowrap border border-gray-300 ${compra.tipo_doc ? "text-black" : "text-gray-200"}`}>
            {capitalizeFirstLetter(compra.tipo_doc)}
          </td>
        )}

        {/* N° comprobante */}
        {activeCols.find((e) => e.id === 7)?.show && (
          <td scope="row" className={`px-4 py-3  text-center whitespace-nowrap border border-gray-300 ${compra.numero_comprobante ? "text-black" : "text-gray-200"}`}>
            {compra.numero_comprobante ? compra.numero_comprobante : "-"}
          </td>
        )}

        {/* Subtotal */}
        {activeCols.find((e) => e.id === 8)?.show && (
          <td scope="row" className={`px-4 py-3  text-center whitespace-nowrap border border-gray-300 ${compra.subtotal ? "text-black" : "text-gray-200"}`}>
            {(compra.moneda === "soles" ? "S/. " : "$ ") + (compra.subtotal ? compra.subtotal.toFixed(2) : "-")}
          </td>
        )}
      
        {/* IGV */}
        {activeCols.find((e) => e.id === 9)?.show && (
          <td scope="row" className={`px-4 py-3 text-center whitespace-nowrap border border-gray-300 ${compra.igv ? "text-black" : "text-gray-200"}`}>
            {(compra.moneda === "soles" ? "S/. " : "$ ") + (compra.igv ? compra.igv.toFixed(2) : "-")}
          </td>
        )}

        {/* Importe total */}
        {activeCols.find((e) => e.id === 10)?.show && (
          <td scope="row" className={`px-4 py-3 text-center whitespace-nowrap border border-gray-300 ${compra.importe_total ? "text-black" : "text-gray-200"}`}>
            {(compra.moneda === "soles" ? "S/. " : "$ ") + (compra.importe_total ? compra.importe_total.toFixed(2) : "-")}
          </td>
        )}

        {/* Comprobante de transacción */}
        {activeCols.find((e) => e.id === 11)?.show && (
          <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
            <div className="flex items-center justify-center gap-2">
              {compra.imagen ? (
                <div className="flex items-center">
                  <DetailsButton 
                    action={() => setShowImageModal(true)} 
                    content="Ver comprobante"                   />
                </div>
              ) : (
                <div className="flex items-center">
                  <label
                    htmlFor={`file-upload-${compra.id}`}
                    className="flex items-center text-green-500 hover:underline cursor-pointer"
                  ></label>
                  <input
                    id={`file-upload-${compra.id}`}
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <div
                    className="p-1.5 text-green-500 hover:bg-green-600 hover:bg-opacity-25 hover:cursor-pointer rounded-md bg-green-700 bg-opacity-10"
                    onClick={openModalAdd}
                    disabled={!selectedFile || isUploading}
                  >
                    {isUploading ? "Subiendo..." : <FaCloudUploadAlt className="text-xs" />}
                  </div>
                </div>
              )}
            </div>
          </td>
        )}

        {/* Documentos de venta */}
        {activeCols.find((e) => e.id === 12)?.show && (
          <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
            <div className="flex items-center justify-center gap-2">
              {compra.documentos && compra.documentos.length > 0 ? (
                <div className="flex items-center gap-1">
                  <span className="text-xs text-gray-600 mr-1">
                    {compra.documentos.length} doc{compra.documentos.length !== 1 ? 's' : ''}
                  </span>
                  <div className="flex items-center gap-1">
                    <DetailsButton 
                      action={() => setShowMultipleDocsViewModal(true)}
                      content="Ver documentos"
                    />
                    <EditButton 
                      action={openEditDocsModal}
                      content="Editar documentos"
                    />
                  </div>
                </div>
              ) : (
                <div className="flex items-center">
                  <button
                    onClick={openMultipleDocsModal}
                    className="p-1.5 text-green-500 hover:bg-green-600 hover:bg-opacity-25 hover:cursor-pointer rounded-md bg-green-700 bg-opacity-10 flex items-center"
                    title="Subir documentos de venta"
                    disabled={isUploadingMultiple}
                  >
                    {isUploadingMultiple ? (
                      <FormLoader colour={"#10B981"} className={"w-3 h-3"} />
                    ) : (
                      <FaCloudUploadAlt className="text-xs" />
                    )}
                  </button>
                </div>
              )}
            </div>
          </td>
        )}

        {/* Estado de pago */}
        {activeCols.find((e) => e.id === 13)?.show && (
          <td scope="row" className={`px-4 py-3 text-center whitespace-nowrap border border-gray-300 ${compra.estadoPago ? "text-black" : "text-gray-200"}`}>
            {compra.estadoPago ? compra.estadoPago : "-"}
          </td>
        )}

        {/* Fecha pago */}
        {activeCols.find((e) => e.id === 14)?.show && (
          <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
            {compra.fecha_pago_real ? formatDate(compra.fecha_pago_real.split("T")[0]) : "-"}
          </td>
        )}

        {/* Tipo de pago */}
        {activeCols.find((e) => e.id === 15)?.show && (
          <td scope="row" className={`px-4 py-3  text-center whitespace-nowrap border border-gray-300 ${compra.tipoPago ? "text-black" : "text-gray-200"}`}>
            {compra.tipoPago ? compra.tipoPago : "-"}
          </td>
        )}

        {/* Moneda */}
        {activeCols.find((e) => e.id === 16)?.show && (
          <td scope="row" className={`px-4 py-3  text-center whitespace-nowrap border border-gray-300 ${compra.moneda ? "text-black" : "text-gray-200"}`}>
            {capitalizeFirstLetter(compra.moneda)}
          </td>
        )}

        {/* Subcategoría */}
        {activeCols.find((e) => e.id === 17)?.show && (
          <td scope="row" className={`px-4 py-3  text-center whitespace-nowrap border border-gray-300 ${compra.subcategoria ? "text-black" : "text-gray-200"}`}>
            {compra.subcategoria ? compra.subcategoria : "-"}
          </td>
        )}

        {/* Categoria */}
        {activeCols.find((e) => e.id === 18)?.show && (
          <td scope="row" className={`px-4 py-3  text-center whitespace-nowrap border border-gray-300 ${compra.categoria ? "text-black" : "text-gray-200"}`}>
            {compra.categoria ? compra.categoria : "-"}
          </td>
        )}

        {/* Entidad de pago*/}
        {activeCols.find((e) => e.id === 19)?.show && (
          <td scope="row" className={`px-4 py-3  text-center whitespace-nowrap border border-gray-300 ${compra.entidad ? "text-black" : "text-gray-200"}`}>
            {compra.entidad ? compra.entidad : "-"}
          </td>
        )}

        {/* Costo unitario */}
        {activeCols.find((e) => e.id === 20)?.show && (
          <td scope="row" className={`px-4 py-3  text-center whitespace-nowrap border border-gray-300 ${compra.costo_unitario ? "text-black" : "text-gray-200"}`}>
            {compra.costo_unitario ? compra.costo_unitario.toFixed(2) : "-"}
          </td>
        )}

        {/* Cantidad de ítems */}
        {activeCols.find((e) => e.id === 21)?.show && (
          <td scope="row" className={`px-4 py-3  text-center whitespace-nowrap border border-gray-300 ${compra.cantidad ? "text-black" : "text-gray-200"}`}>
            {compra.cantidad ? compra.cantidad : "-"}
          </td>
        )}
        
        {/* Tipo de costo */}
        {activeCols.find((e) => e.id === 22)?.show && (
          <td scope="row" className={`px-4 py-3  text-center whitespace-nowrap border border-gray-300 ${compra.tipoCosto ? "text-black" : "text-gray-200"}`}>
            {compra.tipoCosto ? compra.tipoCosto : "-"}
          </td>
        )}
 
      </tr>
    </>
  );
};

export default ItemRowRegistroCompra;
